const showrooms = () => {

    const $pins = $('.js-showroom-pin');
    const $items = $('.js-showroom-map-nav');
    const $tags = $items.find('.js-city-tag');
    const $close = $items.find('.close');
    const $showrooms_grid = $('.js-grid-showrooms');

    $pins.on('click', function () {
        let $this = $(this);
        let open_item = $('.js-showroom-map-nav[data-slug="' + $this.data('open-slug') + '"]');

        $items.removeClass('active');
        open_item.addClass('active');
    });

    $close.on('click', function () {
        $items.removeClass('active');
    });

    $(document).on('click', function (e) {

        if($items.hasClass('active') && !$pins.is(e.target) && $pins.has(e.target).length === 0) {
            if(!$items.is(e.target) && $items.has(e.target).length === 0) {

                $items.removeClass('active');

            }
        }

    });

    $tags.on('click', function () {
        let $this = $(this);
        $('.js-tag[data-tag="' + $this.data('click-tag') + '"]').click();

        let offset = $showrooms_grid.offset().top;

        $('html, body').animate({scrollTop: offset}, 500);
    })

};

export default showrooms;